//TODO Tidy this mess up - urgent
export default class Gesture extends PIXI.Container {
    constructor(texture, points, selfClosing = false, repeating = false, numToComplete = 1) {
        super();

        this.pointsArray = points;
        this.pointSprites = [];
        this.initialPoint = null;
        this.counter = 0;
        this.repeating = repeating;
        this._numToComplete = numToComplete;
        this.numCompleted = 0;
        this.gestureTexture = texture;
        this._selfClosing = selfClosing;
        this._resetting = true;
        this._isComplete = false;

        this._sensitivity = 50;

        this.on('pointerup', ()=>{
            this.pointerUp();
        });
        this.on('pointerupoutside', ()=>{
            this.pointerUp();
        });

        this.on('pointerdown', (interactionData)=>{
            this.pointerDown(interactionData);
        });

        this.on('pointermove', (event)=>{
            this.pointerMove(event);
        });

        this.signals = {};
        this.signals.complete = new P3.utils.MiniSignal();
        this.signals.firstTouch = new P3.utils.MiniSignal();
    }

    checkPoint(currentPosition, targetPosition) {
        let difX = Math.abs(currentPosition.x - targetPosition.x);
        let difY = Math.abs(currentPosition.y - targetPosition.y);

        return difX < this._sensitivity && difY < this._sensitivity;
    }

    determineNextPoint() {
        this.pointSprites[this.counter].texture = this.pointSprites[this.counter]._onTexture;
        if(this.counter + 1 < this.pointSprites.length)
            this.pointSprites[this.counter + 1]._in.start();
        else {

            //this.isDragging = false;
        }

        if(this._isComplete && this.counter === 1){
            this.pointSprites[4]._out.start();
            this.pointSprites[0]._out.start();
        }
        else if(this.counter - 1 >= 0)
            this.pointSprites[this.counter - 1]._out.start();

        if (this.counter + 1 === this.pointsArray.length) {
            this.counter = 0;
            this._isComplete = true;
            this.pointSprites[this.pointSprites.length - 2]._out.start();
            this.pointSprites[this.counter + 1]._in.start();
            this._completeSprite && this._completeSprite.animIn.start();
        } else {
            this.counter++;
            if(!this._isComplete)
                this._isComplete = false;
        }
    }

    createPoints(tweens, useComplete) {
        this.sprite = new PIXI.Sprite(this.gestureTexture);
        this.addChildAt(this.sprite, 0);

        this.interactive = true;

        let createSprite = (position)=>{
            let sprite = new PIXI.Sprite(P3.assets.texture("mix_target_off"));
            sprite.anchor.set(0.5);
            sprite.scale.set(0);
            sprite.position.set(position.x, position.y);
            //sprite.visible = false;
            sprite._onTexture = P3.assets.texture("mix_target_on");
            sprite._offTexture = P3.assets.texture("mix_target_off");
            return sprite;
        };

        for (let i = 0; i < this.pointsArray.length; i++) {
            let sprite = createSprite({x:this.pointsArray[i].x, y:this.pointsArray[i].y});
            this.animatePoint(sprite, tweens);
            this.addChild(sprite);
            this.pointSprites.push(sprite);
        }

        if(this._selfClosing){
            let sprite = createSprite({x:this.pointsArray[0].x, y:this.pointsArray[0].y});
            //sprite.visible = false;
            this.animatePoint(sprite, tweens);
            this.addChild(sprite);
            this.pointSprites.push(sprite);
            this.pointsArray.push(new PIXI.Point(this.pointsArray[0].x, this.pointsArray[0].y))
        }

        this.pointSprites[0].visible = true;
        this.pointSprites[this.pointSprites.length - 1]._out.onComplete(()=>{
            if(!this.isDragging){
                if(this._isComplete)
                    this.signals.complete.dispatch();
            }

            if(this._resetting){
                this._resetting = false;
                this.pointSprites[0]._in.start();
            }
        });
        this.pointSprites[0]._in.start();
        this.pointSprites[0].texture = this.pointSprites[0]._offTexture;

        if(useComplete){
            this._completeSprite = new PIXI.Sprite(P3.assets.texture('mix_complete'));
            this._completeSprite.anchor.set(0.5);
            this._completeSprite.scale.set(0);
            this._completeSprite.position.set(this.pointSprites[0].x, this.pointSprites[0].y + 300);
            this._completeSprite.animIn = new P3.utils.TWEEN.Tween(this._completeSprite.scale, this.tweens)
                .to({
                    x: 0.5, y: 0.5
                }, 340)
                .easing(P3.utils.Easing.Back2.Out);

            //this.addChild(this._completeSprite);
        }
    }

    animatePoint(point, tweens){
        point._out = new P3.utils.TWEEN.Tween(point.scale, tweens)
            .to({
                x: 0, y: 0
            }, 500)
            .easing(P3.utils.TWEEN.Easing.Quadratic.InOut);

        point._in = new P3.utils.TWEEN.Tween(point.scale, tweens)
            .to({
                x: 0.8, y: 0.8
            }, 500)
            .easing(P3.utils.TWEEN.Easing.Quadratic.InOut);
    }

    update(){
    }

    pointerUp(){
        this._resetting = true;
        for (let i = 0; i < this.pointSprites.length; i++) {
            const pointSprite = this.pointSprites[i];
            pointSprite._out.start();
            pointSprite._in.stop();
            pointSprite.texture = pointSprite._offTexture;
        }
        this.pointSprites[0].texture = this.pointSprites[0]._offTexture;
        this.counter = 0;
        this.isDragging = false;
    }

    pointerDown(interactionData){
        this.initialPoint = interactionData.data.getLocalPosition(this);

        if (this.checkPoint(this.initialPoint, this.pointsArray[0])) {
            this.determineNextPoint();
            this.isDragging = true;
        }
        this.signals.firstTouch.dispatch();
    }

    pointerMove(event){
        if (!this.isDragging) return;

        let newPoint = event.data.getLocalPosition(this);

        if (this.checkPoint(newPoint, this.pointsArray[this.counter]))
            this.determineNextPoint();
    }

}